
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"30","viewBox":"0 0 29 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_13200_14051)"}},[_c('path',{attrs:{"d":"M13.893 7.29a.683.683 0 011.216 0l7.466 14.547a.854.854 0 01-.76 1.244H7.187a.854.854 0 01-.76-1.244L13.893 7.29z","fill":"#FFCC4D"}}),_c('path',{attrs:{"d":"M15.999 6.834c-.626-1.22-2.37-1.22-2.996 0L5.538 21.38a1.854 1.854 0 001.65 2.7h14.627a1.854 1.854 0 001.65-2.7L15.998 6.834z","stroke":"#fff","stroke-width":"2"}})]),_c('g',{attrs:{"fill":"#000"}},[_c('path',{attrs:{"d":"M15.696 20.283a1.196 1.196 0 11-2.391 0 1.196 1.196 0 012.391 0zM13.305 12.159c0-.588.535-1.065 1.196-1.065.66 0 1.195.477 1.195 1.065v4.87c0 .588-.535 1.065-1.195 1.065s-1.196-.477-1.196-1.066V12.16z"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_13200_14051","x":".33","y":".919","width":"28.342","height":"28.163","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset'),_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_13200_14051"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_13200_14051","result":"shape"}})])])])
          )
        }
      }
    